import { makeStyles } from '@material-ui/core';
import React from 'react';
const useCMStyles = makeStyles((theme: any) => ({
    filterContainer: {
        marginBottom: 12,
    },
    container: (props: any) => ({
        //height: 'calc(100vh - 327px)',
        //overflowY: 'auto',
        //overflowX: 'auto',
        // overflow: 'auto',
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        // },
        // '&::-webkit-scrollbar-track': {
        //     background: '#f1f1f1',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     background: '#888',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb:hover': {
        //     background: '#555',
        // },
    }),
    card: {
        backgroundColor: '#f6f7f9',
        marginTop: 16,
        color: '#000',
        padding: 16,
    },
    routeContainer: {
        padding: '12px 12px',
        paddingBottom: 0,
    },
    backIcon: {
        minWidth: '0',
        color: '#000000',
        cursor: 'pointer',
        marginRight: '8px',
    },
    scrollableBox: {
        width: '100%',
        height: '38vh',
        overflowY: 'auto',
        minHeight: '38vh',
        maxHeight: '38vh',
        marginTop: 12,
        borderRadius: 16,
    },
    filterBox: {
        width: 'auto',
        height: 'auto',
        minWidth: 160,
        minHeight: 112,
        boxShadow: 'none',
        padding: '12px 16px',
        border: '1px solid #EBEDF8',
        borderRadius: '4px',
        backgroundColor: '#F6F7F9',
        cursor: 'pointer',
    },
    cardHeader: {
        fontSize: '16px',
        fontWeight: 600,
    },
    cardSubHeader: {
        fontSize: '22px',
        fontWeight: 700,
        marginTop: '16px',
    },
    tableContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 364px)',
        maxHeight: 'calc(100vh - 364px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    tableTLContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 452px)',
        maxHeight: 'calc(100vh - 452px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    tableRiderContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 264px)',
        maxHeight: 'calc(100vh - 264px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    tableValue: {
        wordBreak: 'break-all',
        fontWeight: 600,
        fontSize: 16,
    },
    tableSubValue: {
        wordBreak: 'break-all',
        fontWeight: 400,
        fontSize: 14,
        marginTop: '6px',
    },
    tableValueBold: {
        wordBreak: 'break-all',
        fontWeight: 700,
        fontSize: 16,
    },
    chip: {
        fontSize: 12,
        width: 'auto',
        color: ' #fff',
        border: '1px solid #fff',
        borderRadius: '8px',
        padding: '2px 12px',
        //margin: '0px 8px',
        textAlign: 'center',
        backgroundColor: 'black',
    },
    chipText: {
        fontSize: 12,
        color: 'inherit',
    },
    active: {
        backgroundColor: 'rgba(76, 175, 80, 0.16) !important',
        border: '1px solid #4caf50 !important',
        color: '#4caf50 !important',
    },
    activeFill: {
        backgroundColor: '#4caf50 !important',
        border: '1px solid #4caf50 !important',
        color: '#fff !important',
    },
    activeOutlined: {
        backgroundColor: '#fff !important',
        border: '1px solid #D6D6D6 !important',
        color: '#4caf50 !important',
    },
    pending: {
        backgroundColor: 'rgba(255, 152, 0, 0.16) !important',
        border: '1px solid #ff9800 !important',
        color: '#ff9800 !important',
    },
    pendingFill: {
        backgroundColor: '#ff9800 !important',
        border: '1px solid #ff9800 !important',
        color: '#fff !important',
    },
    pendingOutlined: {
        backgroundColor: '#fff !important',
        border: '1px solid #D6D6D6 !important',
        color: '#ff9800 !important',
    },
    reject: {
        backgroundColor: 'rgba(244, 67, 54, 0.16) !important',
        border: '1px solid #f44336 !important',
        color: '#f44336 !important',
    },
    inactive: {
        backgroundColor: 'rgba(63, 81, 181, 0.16) !important',
        border: '1px solid #3f51b5 !important',
        color: '#3f51b5 !important',
    },
    none: {
        backgroundColor: '#F4F4F4',
        border: '1px solid #686868',
        color: '#686868',
    },
    none2: {
        backgroundColor: 'rgba(55, 55, 78, 0.16)',
        border: '1px solid #37374E',
        color: '#37374E',
    },
    menu: {
        border: '1px solid #3f51b5',
        color: ' #3f51b5',
        borderRadius: 8,
        padding: '8px',
    },
    paginationContainer: {},
    cardCX: {
        borderRadius: 8,
        border: '1px solid #EAEAEA',
        background: '#FFF',
    },
}));
export default useCMStyles;
